/* ============================================
   HAEZEL TECH | Dynamic Variant Title v4

   PRODUCT PAGE: Sets title immediately on load from URL ?variant=ID
   COLLECTION GRID: Updates card titles when variant filter active
   Separator between product name and model: middle dot (no dashes)
============================================ */

(function() {
  'use strict';

  var HT_SEP = ' · ';

  // Remove any model suffix already rendered (by Liquid or an older script)
  function htBase(text) {
    return text.trim().split(' · ')[0].split(' — ')[0].trim();
  }

  /* ============================================
     PART 1: PRODUCT PAGE DYNAMIC TITLE
  ============================================ */

  function htGetTitleEl() {
    return document.querySelector('.product__title h1');
  }

  function htSetProductTitle(variantTitle) {
    var titleEl = htGetTitleEl();
    if (!titleEl) return;

    if (!titleEl.dataset.baseTitle) {
      titleEl.dataset.baseTitle = htBase(titleEl.textContent);
    }
    var baseTitle = titleEl.dataset.baseTitle;

    if (!variantTitle || variantTitle === 'Default Title') {
      titleEl.textContent = baseTitle;
    } else {
      titleEl.textContent = baseTitle + HT_SEP + variantTitle;
    }
  }

  function htGetVariantFromUrl() {
    var urlParams = new URLSearchParams(window.location.search);
    var variantId = urlParams.get('variant');
    if (!variantId) return null;

    var variants = window.htProductVariants;
    if (!variants || !variants.length) return null;

    var variant = variants.find(function(v) {
      return String(v.id) === String(variantId);
    });
    return variant ? variant.title : null;
  }

  function htGetVariantFromForm() {
    var checked = document.querySelector(
      'variant-radios input:checked, variant-selects input:checked, .product-form__input input[type="radio"]:checked'
    );
    if (checked && checked.value && checked.value !== 'Default Title') {
      return checked.value;
    }
    var select = document.querySelector('variant-selects select, variant-radios select');
    if (select) {
      var opt = select.options[select.selectedIndex];
      return opt ? opt.text.trim() : null;
    }
    return null;
  }

  // Called from Liquid once variants JSON is injected
  window.htInitProductTitle = function(variants) {
    window.htProductVariants = variants;

    var variantTitle = htGetVariantFromUrl() || htGetVariantFromForm();
    if (variantTitle) {
      htSetProductTitle(variantTitle);
    }

    document.addEventListener('variant:change', function(e) {
      if (e.detail && e.detail.variant) {
        htSetProductTitle(e.detail.variant.title);
      }
    });

    document.addEventListener('change', function(e) {
      if (!e.target) return;
      if (e.target.matches('variant-selects select, variant-radios select, .product-form__input select')) {
        var selected = e.target.options[e.target.selectedIndex];
        if (selected) htSetProductTitle(selected.text.trim());
      }
      if (e.target.matches('variant-radios input[type="radio"], variant-selects input[type="radio"], .product-form__input input[type="radio"]')) {
        setTimeout(function() {
          var v = htGetVariantFromForm();
          if (v) htSetProductTitle(v);
        }, 50);
      }
    });
  };

  /* ============================================
     PART 2: COLLECTION GRID VARIANT TITLES
     Shows model name on card when filter active
  ============================================ */

  function htGetActiveVariantFilter() {
    var urlParams = new URLSearchParams(window.location.search);
    var filterValue = urlParams.get('filter.v.option.size');
    if (filterValue) return decodeURIComponent(filterValue);
    filterValue = urlParams.get('filter.v.option.title');
    if (filterValue) return decodeURIComponent(filterValue);
    return null;
  }

  function htUpdateGridTitles() {
    var activeFilter = htGetActiveVariantFilter();
    var cards = document.querySelectorAll('.card-wrapper');

    cards.forEach(function(card) {
      var titleEl = card.querySelector('.card__heading a, .card__heading .full-unstyled-link');
      if (!titleEl) titleEl = card.querySelector('.card__heading');
      if (!titleEl) return;

      if (!titleEl.dataset.baseTitle) {
        titleEl.dataset.baseTitle = htBase(titleEl.textContent);
      }
      var baseTitle = titleEl.dataset.baseTitle;

      if (activeFilter) {
        var targetTitle = baseTitle + HT_SEP + activeFilter;
        if (titleEl.textContent.trim() !== targetTitle) {
          titleEl.textContent = targetTitle;
        }
      } else {
        if (titleEl.textContent.trim() !== baseTitle) {
          titleEl.textContent = baseTitle;
        }
      }
    });
  }

  function htInitCollectionGrid() {
    if (!document.querySelector('#product-grid, .collection')) return;

    htUpdateGridTitles();

    var origFetch = window.fetch;
    window.fetch = function() {
      return origFetch.apply(this, arguments).then(function(response) {
        setTimeout(htUpdateGridTitles, 300);
        setTimeout(htUpdateGridTitles, 800);
        return response;
      });
    };

    var grid = document.querySelector('#product-grid');
    if (grid) {
      var observer = new MutationObserver(function(mutations) {
        var hasChildChanges = mutations.some(function(m) {
          return m.type === 'childList' && m.addedNodes.length > 0;
        });
        if (hasChildChanges) {
          setTimeout(htUpdateGridTitles, 200);
          setTimeout(htUpdateGridTitles, 600);
        }
      });
      observer.observe(grid, { childList: true, subtree: true });
    }

    var lastUrl = window.location.href;
    setInterval(function() {
      if (window.location.href !== lastUrl) {
        lastUrl = window.location.href;
        setTimeout(htUpdateGridTitles, 500);
        setTimeout(htUpdateGridTitles, 1200);
        setTimeout(htUpdateGridTitles, 2000);
      }
    }, 200);
  }

  /* ============================================
     PART 3: ADD TO CART HOVER
  ============================================ */

  function htAttachCardHover() {
    document.querySelectorAll('.card-wrapper').forEach(function(card) {
      if (card.dataset.hoverInit) return;
      card.dataset.hoverInit = 'true';
      card.addEventListener('mouseenter', function() { card.classList.add('ht-card-hover'); });
      card.addEventListener('mouseleave', function() { card.classList.remove('ht-card-hover'); });
    });
  }

  function htInitCardHover() {
    htAttachCardHover();
    var grid = document.querySelector('#product-grid');
    if (grid) {
      new MutationObserver(function() {
        setTimeout(htAttachCardHover, 200);
      }).observe(grid, { childList: true });
    }
  }

  /* ============================================
     INIT
  ============================================ */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      htInitCollectionGrid();
      htInitCardHover();
    });
  } else {
    htInitCollectionGrid();
    htInitCardHover();
  }

})();

/* ============================================
   PART 4: DEFAULT FILTER (iPhone 18 Pro Max)
   Auto-applies on collection pages when no
   size filter is already active
============================================ */

(function() {
  function htApplyDefaultFilter() {
    if (!document.querySelector('#product-grid')) return;

    var path = window.location.pathname.toLowerCase();

    var isIphoneCollection = path.indexOf('iphone') !== -1
      || path.indexOf('phone-cases') !== -1
      || path.indexOf('medical') !== -1
      || path.indexOf('tradie') !== -1
      || path.indexOf('law-enforcement') !== -1
      || path.indexOf('it-phone') !== -1
      || path.indexOf('student') !== -1
      || path.indexOf('pet-lover') !== -1
      || path.indexOf('luxury') !== -1
      || path.indexOf('vintage') !== -1
      || path.indexOf('travel') !== -1
      || path.indexOf('signature') !== -1
      || path.indexOf('new-arrivals') !== -1
      || path.indexOf('best-sellers') !== -1
      || path.indexOf('healer') !== -1
      || path.indexOf('builder') !== -1
      || path.indexOf('guardian') !== -1
      || path.indexOf('explorer') !== -1
      || path.indexOf('prestige') !== -1
      || path.indexOf('code') !== -1
      || path.indexOf('campus') !== -1;

    if (!isIphoneCollection) return;

    var params = new URLSearchParams(window.location.search);
    var hasFilter = params.get('filter.v.option.size');
    if (hasFilter) return;

    var defaultModel = 'iPhone 18 Pro Max';

    if (path.indexOf('iphone-18-pro-max') !== -1) defaultModel = 'iPhone 18 Pro Max';
    else if (path.indexOf('iphone-18-pro') !== -1) defaultModel = 'iPhone 18 Pro';
    else if (path.indexOf('iphone-18') !== -1) defaultModel = 'iPhone 18 Pro Max';
    else if (path.indexOf('iphone-duo') !== -1) defaultModel = 'iPhone 18 Pro Max';
    else if (path.indexOf('iphone-17-pro-max') !== -1) defaultModel = 'iPhone 17 Pro Max';
    else if (path.indexOf('iphone-17-pro') !== -1) defaultModel = 'iPhone 17 Pro';
    else if (path.indexOf('iphone-17-air') !== -1) defaultModel = 'iPhone 17 Air';
    else if (path.indexOf('iphone-17') !== -1) defaultModel = 'iPhone 17';
    else if (path.indexOf('iphone-16') !== -1) defaultModel = 'iPhone 16 Pro Max';
    else if (path.indexOf('iphone-15') !== -1) defaultModel = 'iPhone 15 Pro Max';
    else if (path.indexOf('iphone-14') !== -1) defaultModel = 'iPhone 14 Pro Max';
    params.set('filter.v.option.size', defaultModel);
    params.delete('filter.v.price.gte');
    params.delete('filter.v.price.lte');
    var newUrl = window.location.pathname + '?' + params.toString();
    window.history.replaceState({}, '', newUrl);

    setTimeout(function() {
      if (typeof FacetFiltersForm !== 'undefined') {
        FacetFiltersForm.renderPage(params.toString(), null, false);
      }
    }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', htApplyDefaultFilter);
  } else {
    htApplyDefaultFilter();
  }
})();
